import { render, staticRenderFns } from "./SoftManager.vue?vue&type=template&id=5e780450&scoped=true&"
import script from "./SoftManager.vue?vue&type=script&lang=js&"
export * from "./SoftManager.vue?vue&type=script&lang=js&"
import style0 from "./SoftManager.vue?vue&type=style&index=0&id=5e780450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e780450",
  null
  
)

export default component.exports